import { createFileRoute } from '@tanstack/react-router';
import { Archive } from 'lucide-react';
import { ComingSoonPage } from '@/components/sysadmin/coming-soon';

export const Route = createFileRoute('/sysadmin/platform/backups')({
  component: () => (
    <ComingSoonPage
      icon={Archive}
      title="Backups"
      specRef="§3.8"
      wave="Phase 6"
      description="PostgreSQL + Qdrant + Valkey snapshot policies. Daily + 6-hour PostgreSQL backups, 14-day Qdrant snapshots, 30-day retention. The Trust → Compliance evidence rail consumes the snapshot manifest as proof of the backup invariant; this surface is where sysadmin tunes the schedule, retention, and off-host replication target."
      bullets={[
        'Snapshot history — PostgreSQL + Qdrant + Valkey, size + duration',
        'RPO 6h / RTO 1h SLA dashboard with last-attempt status',
        'Restore wizard — typed-confirm + audit + dry-run "recovery test"',
        'Off-host replication policy (USB target, S3-compatible, NFS)',
        'Per-tenant retention overrides for ITAR (5y) / CMMC (3y) / commercial',
        'Snapshot integrity verification — checksum + chain-of-custody attestation',
      ]}
    />
  ),
});
